import { Component, Inject, OnInit, Optional, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableExporterModule } from 'mat-table-exporter';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Overtime } from '../_model/overtime';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { OvertimeSearchRequest } from '../_model/request/OvertimeSearchRequest';
import { User } from '../_model/user';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../_services/authentication.service';
import { EventService } from '../_services/event.service';
import { LookupService } from '../_services/lookup.service';
import { UtilityService } from '../_helpers/utility.service';
import { ReportService } from '../_services/report.service';
import { OvertimeService } from '../_services/overtime.service';
import { OvertimeDetailComponent } from './overtime-detail/overtime-detail.component';
import { OvertimeUpdateComponent } from './overtime-update/overtime-update.component';
import { OvertimeRejectComponent } from './overtime-reject/overtime-reject.component';
import { OvertimeApproveComponent } from './overtime-approve/overtime-approve.component';
import { OvertimeDeleteComponent } from './overtime-delete/overtime-delete.component';
import { OvertimeRejectSelectedComponent } from './overtime-reject-selected/overtime-reject-selected.component';
import { OvertimeApproveSelectedComponent } from './overtime-approve-selected/overtime-approve-selected.component';
import { AppConstants } from '../_utils/constants';
import { OvertimeReportPeriodsRequest } from '../_model/request/OvertimeReportPeriodsRequest';
import { OvertimeLookup } from '../_model/OvertimeLookup';
import { forkJoin } from 'rxjs';
import { AbsenceReportRequest } from '../_model/request/AbsenceReportRequest';
import { OvertimeReportRequest } from '../_model/request/OvertimeReportRequest';
import moment from 'moment';
import { CustomDatePipe } from '../_pipe/custom-date.pipe';

export enum ExportType {
  PDF = 'PDF',
  EXCEL = 'EXCEL'
}
@Component({
  selector: 'app-overtime',
  templateUrl: './overtime.component.html',
  styleUrls: ['./overtime.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTabsModule,
    MatSelectModule,
    MatIconModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    FontAwesomeModule,
    MatTableExporterModule,
    CustomDatePipe
  ]
})
export class OvertimeComponent implements OnInit {

  @ViewChild('myRequestPaginator', { static: false }) myRequestPaginator: MatPaginator;
  @ViewChild('myApprovalsPaginator', { static: false }) myApprovalsPaginator: MatPaginator;
  @ViewChild('rejectsPaginator', { static: false }) rejectsPaginator: MatPaginator;
  @ViewChild('waitingsPaginator', { static: false }) waitingsPaginator: MatPaginator;
  @ViewChild('allPaginator', { static: false }) allPaginator: MatPaginator;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;

  // sort objects
  @ViewChild('WaitingSort', { static: false }) waitingSort: MatSort;
  @ViewChild('ApprovalSort', { static: false }) approvalSort: MatSort;
  @ViewChild('RejectSort', { static: false }) rejectSort: MatSort;
  @ViewChild('MyRequestSort', { static: false }) myRequestSort: MatSort;
  @ViewChild('AllSort', { static: false }) allSort: MatSort;

  displayedColumns: string[] = ['isCompleted', 'name', 'departmentName', 'overtimeTypeName', 'overtimeDay', 'freeDayAmount', 'overtimeStartDate', 'overtimeEndDate', 'description', 'branchName', 'projectName', 'actions'];
  displayedColumnsWaiting: string[] = ['select', 'name', 'departmentName', 'overtimeTypeName', 'overtimeDay', 'freeDayAmount', 'overtimeStartDate', 'overtimeEndDate', 'description', 'branchName', 'projectName', 'actions'];

  // Datasources
  dataSource: MatTableDataSource<any>;
  dsMyRequest: MatTableDataSource<any>;
  dsMyApprovals: MatTableDataSource<any>;
  dsRejects: MatTableDataSource<any>;
  dsWaitings: MatTableDataSource<any>;
  dsAll: MatTableDataSource<any>;
  filterValue = null;
  selectedTab = 0;
  currentUser: User;
  overtimeList: Overtime[];
  selectedovertime: Overtime;
  fileUploadRoot = environment.fileUploadPath;
  selection = new SelectionModel<Overtime>(true, []);

  // filter values
  startDateFilterValue1: any = new FormControl(); // new FormControl(moment());
  endDateFilterValue1: any = new FormControl();
  startDateFilterValue2: any = new FormControl();
  endDateFilterValue2: any = new FormControl();
  startDateFilterValue3: any = new FormControl();
  endDateFilterValue3: any = new FormControl();
  startDateFilterValue4: any = new FormControl();
  endDateFilterValue4: any = new FormControl();
  startDateFilterValue5: any = new FormControl();
  endDateFilterValue5: any = new FormControl();
  overtimeTypeList: any[] = [{ id: null, description: 'Hepsi' }];
  selectedovertimeType1: any = this.overtimeTypeList[0];
  selectedovertimeType2: any = this.overtimeTypeList[0];
  selectedovertimeType3: any = this.overtimeTypeList[0];
  selectedovertimeType4: any = this.overtimeTypeList[0];
  selectedovertimeType5: any = this.overtimeTypeList[0];
  departmentList: any[] = [{ description: 'Hepsi' }];
  StatuList: any[] = [{ description: 'Hepsi' }, { id: 0, description: 'Bekliyor' }, { id: 1, description: 'Onaylandı' }, { id: -1, description: 'Reddedildi' }];
  authDepartmentList: any[] = [{ description: 'Hepsi' }];
  employeeList: any[] = [{ description: 'Hepsi' }];
  selectedAuthDepartment = this.authDepartmentList[0];
  selectedEmployee = null;
  selectedDepartment1: any = this.departmentList[0];
  selectedDepartment2: any = this.departmentList[0];
  selectedDepartment3: any = this.departmentList[0];
  selectedDepartment4: any = this.departmentList[0];
  selectedDepartment5: any = this.departmentList[0];
  selectedStatu5: any = this.StatuList[0];
  date = new FormControl(moment());
  searchFullName1 = '';
  searchFullName2 = '';
  searchFullName3 = '';
  searchFullName4 = '';
  searchFullName5 = '';

  size = 20;
  pageNumber = 0;
  overtimeSearchRequest: OvertimeSearchRequest = new OvertimeSearchRequest(this.pageNumber, this.size, null, null);

  // fontawesome icon
  fileExcelIcon = faFileExcel;

  // pagination parameters
  paginatorIntl = new MatPaginatorIntl();

  reportForm: FormGroup;

  overtimeBranchList: OvertimeLookup[];
  overtimeProjectList: OvertimeLookup[];
  overtimeTenantList: OvertimeLookup[];

  selectedOvertimeBranch1: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeProject1: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeTenant1: OvertimeLookup = new OvertimeLookup();

  selectedOvertimeBranch2: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeProject2: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeTenant2: OvertimeLookup = new OvertimeLookup();

  selectedOvertimeBranch3: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeProject3: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeTenant3: OvertimeLookup = new OvertimeLookup();

  selectedOvertimeBranch4: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeProject4: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeTenant4: OvertimeLookup = new OvertimeLookup();

  selectedOvertimeBranch5: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeProject5: OvertimeLookup = new OvertimeLookup();
  selectedOvertimeTenant5: OvertimeLookup = new OvertimeLookup();


  selectedExportType: ExportType = ExportType.PDF; // Default değer
  ExportType = ExportType;

  constructor(private overtimeService: OvertimeService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime[],
    private toastr: ToastrService,
    public dialog: MatDialog,
    public authService: AuthenticationService,
    public eventService: EventService,
    private lookupService: LookupService,
    private utilityService: UtilityService,
    private formBuilder: FormBuilder,
    private reportService: ReportService) {

    // Geçen ayın ilk günü
    const lastMonthFirstDay = moment().subtract(1, 'month').startOf('month').toDate();
    // Geçen ayın son günü  
    const lastMonthLastDay = moment().subtract(1, 'month').endOf('month').toDate();

    this.reportForm = this.formBuilder.group({
      department: ['', [Validators.required]],
      employee: [''],
      reportStartDate: [lastMonthFirstDay, [Validators.required]],
      reportEndDate: [lastMonthLastDay, [Validators.required]],
      isRestDay: [0],
      isEmployeeReport: [1],
      reportProject: [''],
      reportTenant: [''],
      exportType: [ExportType.PDF]
    });
  }

  ngOnInit() {
    this.selection = new SelectionModel<Overtime>(true, []);
    this.selectedExportType = ExportType.PDF;
    this.getWaitingData();
    this.getMyRequestData();
    this.getApprovalData();
    this.getRejectData();
    this.getAllData();
    this.currentUser = this.authService.currentUserValue;

    this.lookupService.listByLookupCode('BRANCH');
    this.lookupService.listByLookupCode('PROJECT');
    this.lookupService.listByLookupCode('TENANT');

    forkJoin([
      this.lookupService.listByLookupCode('BRANCH'),
      this.lookupService.listByLookupCode('PROJECT'),
      this.lookupService.listByLookupCode('TENANT')
    ]).subscribe({
      next: async ([branchList, projectList, tenantList]) => {
        this.overtimeBranchList = branchList.responseData.items;
        this.overtimeProjectList = projectList.responseData.items;
        this.overtimeTenantList = tenantList.responseData.items;
      },
      error: (err) => {
        console.error('Error during service calls:', err);
      }
    });

    this.departmentList.push(...this.lookupService.localListByLookupCode('DEPARTMENT').filter(dept => dept.parentLookup || dept.parentLookup !== null).sort((a, b) =>
      a.lookupCode.toLowerCase().localeCompare(b.lookupCode.toLowerCase(), 'tr')
    ));

    this.overtimeService.getDepartmentList().subscribe(result => {
      this.authDepartmentList = result.responseData.items;
      if (this.authDepartmentList.length > 1) {
        this.reportForm.controls['department'].setValue(this.authDepartmentList[0]);
        this.selectedAuthDepartment = this.authDepartmentList[0];
        this.departmentChanged();
      }
    });

    // this.overtimeTypeList1.push(...this.lookupService.localListByLookupCode('overtime_TYPE'));
    this.overtimeTypeList.push(...this.lookupService.localListByLookupCode('OVERTIME_TYPE')
      //.map(z => ({ description: z.description }))
      .sort((a, b) =>
        a.description.toLowerCase().localeCompare(b.description.toLowerCase(), 'tr')
      ));
  }

  getAllData() {
    this.overtimeService.listOvertimes(this.overtimeSearchRequest).subscribe(overtimes => {
      this.dsAll = new MatTableDataSource(overtimes.responseData.items)

      this.allPaginator.length = overtimes.totalCount;
      this.allPaginator.pageIndex = this.overtimeSearchRequest.pageNumber;
      this.allPaginator.pageSize = this.overtimeSearchRequest.size;
      this.allPaginator._intl = this.paginatorIntl;

      this.dsAll.filterPredicate =
        (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
          JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.overtimeTypeName + ' ' + data.description)).includes(filter);

    });
  }

  getRejectData() {
    this.overtimeService.listOvertimeRejecteds(this.overtimeSearchRequest).subscribe(overtimes => {
      this.dsRejects = new MatTableDataSource(overtimes.responseData.items);

      this.rejectsPaginator.length = overtimes.totalCount;
      this.rejectsPaginator.pageIndex = this.overtimeSearchRequest.pageNumber;
      this.rejectsPaginator.pageSize = this.overtimeSearchRequest.size;
      this.rejectsPaginator._intl = this.paginatorIntl;

      this.dsRejects.filterPredicate =
        (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
          JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.overtimeTypeName + ' ' + data.description)).includes(filter);

    });
  }

  getApprovalData() {
    this.overtimeService.listOvertimeApproveds(this.overtimeSearchRequest).subscribe(overtimes => {
      this.dsMyApprovals = new MatTableDataSource(overtimes.responseData.items);

      this.myApprovalsPaginator.length = overtimes.totalCount;
      this.myApprovalsPaginator.pageIndex = this.overtimeSearchRequest.pageNumber;
      this.myApprovalsPaginator.pageSize = this.overtimeSearchRequest.size;
      this.myApprovalsPaginator._intl = this.paginatorIntl;

      this.dsMyApprovals.filterPredicate =
        (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
          JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.overtimeTypeName + ' ' + data.description)).includes(filter);

    });
  }

  getMyRequestData() {
    this.overtimeService.listMyOvertimeRequests(this.overtimeSearchRequest).subscribe(overtimes => {
      this.dsMyRequest = new MatTableDataSource(overtimes.responseData.items);

      this.myRequestPaginator.length = overtimes.totalCount;
      this.myRequestPaginator.pageIndex = this.overtimeSearchRequest.pageNumber;
      this.myRequestPaginator.pageSize = this.overtimeSearchRequest.size;
      this.myRequestPaginator._intl = this.paginatorIntl;

      this.dsMyRequest.filterPredicate =
        (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
          JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.overtimeTypeName + ' ' + data.description)).includes(filter);

    });
  }

  getWaitingData() {
    this.overtimeService.listOvertimeWaitings(this.overtimeSearchRequest).subscribe(overtimes => {
      this.dsWaitings = new MatTableDataSource(overtimes.responseData.items);

      this.waitingsPaginator.length = overtimes.totalCount;
      this.waitingsPaginator.pageIndex = this.overtimeSearchRequest.pageNumber;
      this.waitingsPaginator.pageSize = this.overtimeSearchRequest.size;
      this.waitingsPaginator._intl = this.paginatorIntl;

      this.dsWaitings.filterPredicate =
        (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
          JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.overtimeTypeName + ' ' + data.description)).includes(filter);

    });
  }

  reportTab(tabNo: number, pageStatus: string) {

    // change datasource by using filters
    if (tabNo === 0) { // onay bekleyen
      let selectedDate = new Date(this.endDateFilterValue1.value);
      selectedDate.setHours(23, 59, 59, 0);

      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue1.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType1.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment1.id;
      this.overtimeSearchRequest.fullName = this.searchFullName1;

    } else if (tabNo === 1) { // izinlerim
      let selectedDate = new Date(this.endDateFilterValue2.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue2.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType2.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment2.id;
      this.overtimeSearchRequest.fullName = this.searchFullName2;

    } else if (tabNo === 2) { // onayladiklarim
      let selectedDate = new Date(this.endDateFilterValue3.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue3.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType3.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment3.id;
      this.overtimeSearchRequest.fullName = this.searchFullName3;

    } else if (tabNo === 3) { // reddediklerim
      let selectedDate = new Date(this.endDateFilterValue4.value);
      selectedDate.setHours(23, 59, 59, 0);

      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue4.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType4.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment4.id;
      this.overtimeSearchRequest.fullName = this.searchFullName4;

    } else if (tabNo === 4) { // tum izinler
      //this.dsAll.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue5.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue5.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType5.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment5.id;
      this.overtimeSearchRequest.status = this.selectedStatu5.id;
      this.overtimeSearchRequest.fullName = this.searchFullName5;

    }
    const overtimeReportRequest = new OvertimeReportRequest(this.overtimeSearchRequest, pageStatus);

    this.overtimeService.getReportData(overtimeReportRequest).subscribe(reportResult => {
      const excelData = this.reportService.convertOvertimeReportResponseToSheetDataWithName(reportResult.responseData.item);
      this.reportService.exportAsExcelFile(excelData, reportResult.responseData.item.workBookName);
    });
  }

  clearfilterGrid(tabNo: number, pageStatus: string) {

    if (tabNo === 0) {
      this.selectedovertimeType1 = this.overtimeTypeList[0];
      this.selectedDepartment1 = this.departmentList[0];
      this.startDateFilterValue1.setValue(null);
      this.endDateFilterValue1.setValue(null);
      this.selectedOvertimeBranch1 = null;
      this.selectedOvertimeProject1 = null;
      this.selectedOvertimeTenant1 = null;
      this.searchFullName1 = null;
    } else if (tabNo === 1) {
      this.selectedovertimeType2 = this.overtimeTypeList[0];
      this.selectedDepartment2 = this.departmentList[0];
      this.startDateFilterValue2.setValue(null);
      this.endDateFilterValue2.setValue(null);
      this.searchFullName2 = null;
      this.selectedOvertimeBranch2 = null;
      this.selectedOvertimeProject2 = null;
      this.selectedOvertimeTenant2 = null;
    } else if (tabNo === 2) {
      this.selectedovertimeType3 = this.overtimeTypeList[0];
      this.selectedDepartment3 = this.departmentList[0];
      this.startDateFilterValue3.setValue(null);
      this.endDateFilterValue3.setValue(null);
      this.searchFullName3 = null;
      this.selectedOvertimeBranch3 = null;
      this.selectedOvertimeProject3 = null;
      this.selectedOvertimeTenant3 = null;
    } else if (tabNo === 3) {
      this.selectedovertimeType4 = this.overtimeTypeList[0];
      this.selectedDepartment4 = this.departmentList[0];
      this.startDateFilterValue4.setValue(null);
      this.endDateFilterValue4.setValue(null);
      this.searchFullName4 = null;
      this.selectedOvertimeBranch4 = null;
      this.selectedOvertimeProject4 = null;
      this.selectedOvertimeTenant4 = null;
    } else if (tabNo === 4) {
      this.selectedovertimeType5 = this.overtimeTypeList[0];
      this.selectedDepartment5 = this.departmentList[0];
      this.startDateFilterValue5.setValue(null);
      this.endDateFilterValue5.setValue(null);
      this.searchFullName5 = null;
      this.selectedOvertimeBranch5 = null;
      this.selectedOvertimeProject5 = null;
      this.selectedOvertimeTenant5 = null;
      this.selectedStatu5 = null;
    }
    this.filterGrid(tabNo, pageStatus);
  }

  filterGrid(tabNo: number, pageStatus: string) {

    this.overtimeSearchRequest.pageNumber = 0;
    // change datasource by using filters
    if (tabNo === 0) { // onay bekleyen
      //this.dsWaitings.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue1.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue1.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType1.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment1.id;
      this.overtimeSearchRequest.fullName = this.searchFullName1;
      this.overtimeSearchRequest.branchCode = this.selectedOvertimeBranch1 ? this.selectedOvertimeBranch1.lookupValue : null;
      this.overtimeSearchRequest.projectCode = this.selectedOvertimeProject1 ? this.selectedOvertimeProject1.lookupValue : null;
      this.overtimeSearchRequest.tenantCode = this.selectedOvertimeTenant1 ? this.selectedOvertimeTenant1.lookupValue : null;
      this.getWaitingData();
    } else if (tabNo === 1) { // izinlerim
      //this.dsMyRequest.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue2.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue2.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType2.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment2.id;
      this.overtimeSearchRequest.fullName = this.searchFullName2;
      this.overtimeSearchRequest.branchCode = this.selectedOvertimeBranch2 ? this.selectedOvertimeBranch2.lookupValue : null;
      this.overtimeSearchRequest.projectCode = this.selectedOvertimeProject2 ? this.selectedOvertimeProject2.lookupValue : null;
      this.overtimeSearchRequest.tenantCode = this.selectedOvertimeTenant2 ? this.selectedOvertimeTenant2.lookupValue : null;
      this.getMyRequestData();
    } else if (tabNo === 2) { // onayladiklarim
      //this.dsMyApprovals.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue3.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue3.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType3.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment3.id;
      this.overtimeSearchRequest.fullName = this.searchFullName3;
      this.overtimeSearchRequest.branchCode = this.selectedOvertimeBranch3 ? this.selectedOvertimeBranch3.lookupValue : null;
      this.overtimeSearchRequest.projectCode = this.selectedOvertimeProject3 ? this.selectedOvertimeProject3.lookupValue : null;
      this.overtimeSearchRequest.tenantCode = this.selectedOvertimeTenant3 ? this.selectedOvertimeTenant3.lookupValue : null;
      this.getApprovalData();
    } else if (tabNo === 3) { // reddediklerim
      //this.dsRejects.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue4.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue4.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType4.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment4.id;
      this.overtimeSearchRequest.fullName = this.searchFullName4;
      this.overtimeSearchRequest.branchCode = this.selectedOvertimeBranch4 ? this.selectedOvertimeBranch4.lookupValue : null;
      this.overtimeSearchRequest.projectCode = this.selectedOvertimeProject4 ? this.selectedOvertimeProject4.lookupValue : null;
      this.overtimeSearchRequest.tenantCode = this.selectedOvertimeTenant4 ? this.selectedOvertimeTenant4.lookupValue : null;
      this.getRejectData();
    } else if (tabNo === 4) { // tum izinler
      //this.dsAll.data = this.filterData(pageStatus, tabNo);
      let selectedDate = new Date(this.endDateFilterValue5.value);
      selectedDate.setHours(23, 59, 59, 0);
      this.overtimeSearchRequest.overtimeStartDate = this.startDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue5.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeEndDate = this.endDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
      this.overtimeSearchRequest.overtimeTypeId = this.selectedovertimeType5.id;
      this.overtimeSearchRequest.departmentId = this.selectedDepartment5.id;
      this.overtimeSearchRequest.status = this.selectedStatu5.id;
      this.overtimeSearchRequest.fullName = this.searchFullName5;
      this.overtimeSearchRequest.branchCode = this.selectedOvertimeBranch5 ? this.selectedOvertimeBranch5.lookupValue : null;
      this.overtimeSearchRequest.projectCode = this.selectedOvertimeProject5 ? this.selectedOvertimeProject5.lookupValue : null;
      this.overtimeSearchRequest.tenantCode = this.selectedOvertimeTenant5 ? this.selectedOvertimeTenant5.lookupValue : null;
      this.getAllData();
    }
  }

  openDetail(row) {

    const dialogRef = this.dialog.open(OvertimeDetailComponent, {
      width: '550px',
      height: 'auto',
      data: row
    });

    dialogRef.afterClosed();
  }

  openOvertimeCreateModal(isNew: boolean, overtime?: Overtime) {

    let modalData = new Overtime();
    if (overtime != null) {
      overtime.isNew = isNew;
      modalData = overtime;
    } else {
      modalData.isNew = isNew;
    }
    const dialogRef = this.dialog.open(OvertimeUpdateComponent, {
      width: '650px',
      height: 'auto',
      data: modalData
    });

    // this.dsMyRequest.filter = null;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.dsMyRequest.data.unshift(result.data);
        this.dsMyRequest._updateChangeSubscription();
      }
      // tabloda ilgili satiri bul ve yer degistir
      if (this.filterValue != null) {
        this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
      }
    });
  }

  /**
      * tabNo= overtimeComponentte bulunan sekmelerin sira numarasi
      * simdilik boyle bir ayrim ile islemlerimizi gerceklestiriyoruz
      */
  openUpdateModal(overtime: Overtime, tabNo: number) {

    overtime.tabNo = tabNo;
    overtime.isNew = false;
    this.selectedovertime = overtime;
    const dialogRef = this.dialog.open(OvertimeUpdateComponent, {
      width: '650px',
      height: 'auto',
      data: overtime

    });
    this.dsMyRequest.filter = null;
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (tabNo === 1) {
          const overtimeIndex = this.dsWaitings.data.findIndex(abs => abs.id === result.data.id);
          this.dsWaitings.data.splice(overtimeIndex, 1, result.data);
          this.dsWaitings._updateChangeSubscription();
        } else if (tabNo === 2) {
          const overtimeIndex = this.dsMyRequest.data.findIndex(abs => abs.id === result.data.id);
          this.dsMyRequest.data.splice(overtimeIndex, 1, result.data);
          this.dsMyRequest._updateChangeSubscription();
        } else if (tabNo === 5) {
          const overtimeIndex = this.dsAll.data.findIndex(abs => abs.id === result.data.id);
          this.dsAll.data.splice(overtimeIndex, 1, result.data);
          this.dsAll._updateChangeSubscription();
        }
      }
      // tabloda ilgili satiri bul ve yer degistir
      if (this.filterValue != null) {
        this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
      }
    });
  }

  openDeleteModal(overtime: Overtime) {
    this.selectedovertime = overtime;
    const dialogRef = this.dialog.open(OvertimeDeleteComponent, {
      width: '300px',
      data: overtime
    });

    dialogRef.afterClosed().subscribe(result => {
      const overtimeIndex = this.dsMyRequest.data.findIndex(abs => abs.id === result.data);
      this.dsMyRequest.data.splice(overtimeIndex, 1);
      this.dsMyRequest._updateChangeSubscription();
      this.ngOnInit();
    });
  }

  openApproveModal(overtime: Overtime) {
    this.selectedovertime = overtime;

    const dialogRef = this.dialog.open(OvertimeApproveComponent, {
      width: '400px',
      minHeight: '80px',
      data: overtime
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        const overtimeIndex = this.dsWaitings.data.findIndex(abs => abs.id === overtime.id);
        this.dsWaitings.data.splice(overtimeIndex, 1);
        this.dsWaitings._updateChangeSubscription();
      }
      this.ngOnInit();
    });
  }

  openApproveSelectedModal() {
    const dialogRef = this.dialog.open(OvertimeApproveSelectedComponent, {
      width: '300px',
      data: this.selection.selected
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  openRejectSelectedModal() {

    const dialogRef = this.dialog.open(OvertimeRejectSelectedComponent, {
      width: '300px',
      data: this.selection.selected
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }
  openRejectModal(overtime: Overtime) {
    this.selectedovertime = overtime;

    const dialogRef = this.dialog.open(OvertimeRejectComponent, {
      width: '400px',
      data: overtime
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        const overtimeIndex = this.dsWaitings.data.findIndex(abs => abs.id === overtime.id);
        this.dsWaitings.data.splice(overtimeIndex, 1);
        this.dsWaitings._updateChangeSubscription();
      }
      this.ngOnInit();
    });
  }

  pageEventOfAll(pageEvent: PageEvent) {
    this.overtimeSearchRequest.size = pageEvent.pageSize;
    this.overtimeSearchRequest.pageNumber = pageEvent.pageIndex;
    this.getAllData();

  }

  pageEventOfWaitings(pageEvent: PageEvent) {
    this.overtimeSearchRequest.size = pageEvent.pageSize;
    this.overtimeSearchRequest.pageNumber = pageEvent.pageIndex;
    this.getWaitingData();
  }

  pageEventOfMyRequests(pageEvent: PageEvent) {
    this.overtimeSearchRequest.size = pageEvent.pageSize;
    this.overtimeSearchRequest.pageNumber = pageEvent.pageIndex;
    this.getMyRequestData();
  }

  pageEventOfApprovals(pageEvent: PageEvent) {
    this.overtimeSearchRequest.size = pageEvent.pageSize;
    this.overtimeSearchRequest.pageNumber = pageEvent.pageIndex;
    this.getApprovalData();
  }

  pageEventOfRejects(pageEvent: PageEvent) {
    this.overtimeSearchRequest.size = pageEvent.pageSize;
    this.overtimeSearchRequest.pageNumber = pageEvent.pageIndex;
    this.getRejectData();
  }

  sortChangeOfWaitings($event) {
    const sortId = $event.active;
    const sortDirection = $event.direction;
    this.overtimeSearchRequest.sortColumn = sortId;
    this.overtimeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
    this.overtimeSearchRequest.pageNumber = this.waitingsPaginator.pageIndex;
    this.getWaitingData();
  }

  sortChangeOfMyRequest($event) {
    const sortId = $event.active;
    const sortDirection = $event.direction;
    this.overtimeSearchRequest.sortColumn = sortId;
    this.overtimeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
    this.overtimeSearchRequest.pageNumber = this.myRequestPaginator.pageIndex;
    this.getMyRequestData();
  }

  sortChangeOfApprovals($event) {
    const sortId = $event.active;
    const sortDirection = $event.direction;
    this.overtimeSearchRequest.sortColumn = sortId;
    this.overtimeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
    this.overtimeSearchRequest.pageNumber = this.myApprovalsPaginator.pageIndex;
    this.getApprovalData();
  }

  sortChangeOfRejects($event) {
    const sortId = $event.active;
    const sortDirection = $event.direction;
    this.overtimeSearchRequest.sortColumn = sortId;
    this.overtimeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
    this.overtimeSearchRequest.pageNumber = this.rejectsPaginator.pageIndex;
    this.getRejectData();
  }

  sortChangeOfAll($event) {
    const sortId = $event.active;
    const sortDirection = $event.direction;
    this.overtimeSearchRequest.sortColumn = sortId;
    this.overtimeSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
    this.overtimeSearchRequest.pageNumber = this.allPaginator.pageIndex;
    this.getAllData();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dsWaitings.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dsWaitings.data.forEach(row => this.selection.select(row));
  }

  getOvertimePaymentReport() {

    if (!this.reportForm.valid) return;

    const params = new OvertimeReportPeriodsRequest();
    params.all = this.reportForm.value.isRestDay;
    params.beginPeriod = this.formatDateToMMYYYY(this.reportForm.value.reportStartDate);
    params.departmentId = this.reportForm.value.department.id;
    params.employeeId = this.reportForm.value.employee ? this.reportForm.value.employee.id : null;
    params.endPeriod = this.formatDateToMMYYYY(this.reportForm.value.reportEndDate);
    params.reportType = 'MEAL';
    params.exportType = this.selectedExportType;
    params.projectCode = this.reportForm.get('reportProject').value ? this.reportForm.get('reportProject').value.lookupValue : null;
    params.tenantCode = this.reportForm.get('reportTenant').value ? this.reportForm.get('reportTenant').value.lookupValue : null;
    params.isEmployeeReport = this.reportForm.get('isEmployeeReport').value === 1 || this.reportForm.get('isEmployeeReport').value === true ? 1 : 0;
    params.isRestDay = this.reportForm.get('isRestDay').value === 1 || this.reportForm.get('isRestDay').value === true ? 1 : 0;

    this.overtimeService.getReportPeriods(params).subscribe(reportResult => {
      //open pdf file in new tab
      //EXCEL ise download yapacak , pdf ise yeni sekmede acacak  
      if (params.exportType == 'PDF') {
        const base64Data = reportResult.responseData.item; // Base64 verisi
        const fileType = 'application/pdf'; // Dosya türü (örneğin, 'application/pdf' veya 'image/png')
        this.openBase64InNewTab(base64Data, fileType);
      }
      else if (params.exportType == 'EXCEL') {
        const base64Data = reportResult.responseData.item; // Base64 verisi
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; // Excel dosya türü
        this.downloadBase64File(base64Data, fileType, `Öğün Hakediş_${Date.now()}_${Math.floor(Math.random() * 10000)}.xlsx`);
      }
    }, error => {
      console.error(error);
    });
  }

  getOvertimeReport() {

    if (!this.reportForm.valid) return;

    const params = new OvertimeReportPeriodsRequest();
    params.all = this.reportForm.value.isRestDay;
    params.beginPeriod = this.formatDateToMMYYYY(this.reportForm.value.reportStartDate);
    params.departmentId = this.reportForm.value.department.id;
    params.employeeId = this.reportForm.value.employee ? this.reportForm.value.employee.id : null;
    params.endPeriod = this.formatDateToMMYYYY(this.reportForm.value.reportEndDate);
    params.reportType = 'OVERTIME'; params.projectCode = this.reportForm.get('reportProject').value ? this.reportForm.get('reportProject').value.lookupValue : null;
    params.tenantCode = this.reportForm.get('reportTenant').value ? this.reportForm.get('reportTenant').value.lookupValue : null;
    params.exportType = this.selectedExportType
    params.isEmployeeReport = this.reportForm.get('isEmployeeReport').value === 1 || this.reportForm.get('isEmployeeReport').value === true ? 1 : 0;
    params.isRestDay = this.reportForm.get('isRestDay').value === 1 || this.reportForm.get('isRestDay').value === true ? 1 : 0;
    //EXCEL ise download yapacak , pdf ise yeni sekmede acacak

    this.overtimeService.getReportPeriods(params).subscribe(reportResult => {
      //open pdf file in new tab
      //EXCEL ise download yapacak , pdf ise yeni sekmede acacak  
      if (params.exportType == 'PDF') {
        const base64Data = reportResult.responseData.item; // Base64 verisi
        const fileType = 'application/pdf'; // Dosya türü (örneğin, 'application/pdf' veya 'image/png')
        this.openBase64InNewTab(base64Data, fileType);
      }
      else if (params.exportType == 'EXCEL') {
        const base64Data = reportResult.responseData.item; // Base64 verisi
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; // Excel dosya türü
        this.downloadBase64File(base64Data, fileType, `Fazla Mesai_${Date.now()}_${Math.floor(Math.random() * 10000)}.xlsx`);
      }

    }, error => {
      console.error(error);
    });
  }

  downloadBase64File(base64Data: string, fileType: string, fileName: string) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  openBase64InNewTab(base64Data: string, fileType: string) {
    const byteCharacters = atob(base64Data); // Base64 verisini decode et
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType }); // Blob oluştur
    const blobUrl = URL.createObjectURL(blob); // Blob'u URL'e dönüştür

    // Yeni sekmede aç
    const newTab = window.open();
    if (newTab) {
      newTab.location.href = blobUrl;
    } else {
      console.error('Yeni sekme açılamadı. Pop-up engelleyici etkin olabilir.');
    }
  }

  formatDateToMMYYYY(date: Date): string {
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${month}${year}`;
  }

  setEndDateMonthAndClose(event: moment.Moment, datepicker: MatDatepicker<any>) {
    const formattedDate = event.format('MM/YYYY'); // Moment formatlama
    this.reportForm.get('reportEndDate').setValue(moment(event, AppConstants.MOMENT_MONTH_FORMAT).endOf('month').toDate());
    datepicker.close();
  }

  setStartDateMonthAndClose(event: Date, datepicker: MatDatepicker<any>) {
    this.reportForm.get('reportStartDate').setValue(moment(event, AppConstants.MOMENT_MONTH_FORMAT).toDate());
    datepicker.close();
  }

  departmentChanged() {
    this.overtimeService.getEmployeeList(this.selectedAuthDepartment.id).subscribe(result => {
      this.employeeList = result.responseData.items;
      this.selectedEmployee = null;
      this.reportForm.controls['employee'].setValue(null);
    });
  }

  overtimeProjectChanged() {
    this.selectedOvertimeTenant1 = null;
    this.selectedOvertimeTenant2 = null;
    this.selectedOvertimeTenant3 = null;
    this.selectedOvertimeTenant4 = null;
    this.selectedOvertimeTenant5 = null;
  }

  onExportTypeChange(event: MatButtonToggleChange): void {
    this.selectedExportType = event.value;
    console.log('Export type changed:', this.selectedExportType);
  }

  overtimeTypeChanged() {

  }
}
